import script from "./Excess.vue?vue&type=script&setup=true&lang=ts"
export * from "./Excess.vue?vue&type=script&setup=true&lang=ts"

import "./Excess.vue?vue&type=style&index=0&id=34890aa3&lang=less"

const __exports__ = script;

export default __exports__